<template>
  <transition name="fade">
    <div>
      <div style="height: 100px; width: 100%"></div>
      <vs-card v-if="show" class="fixed bottom-0 left-0 right-0 p-0 m-0 z-1000">
        <div class="lg:w-3/4">
          <div class="flex justify-end items-center">
            <p class="pr-10">У вас есть несохранённые изменения</p>
            <vs-button
              class="float-right mr-6 vs-con-loading__container"
              :disabled="loading"
              @click.prevent="$emit('accept')">
              <div v-if="loading" class="con-vs-loading vs-loading-background-primary vs-loading-color-#fff">
                <div class="vs-loading default" style="transform: scale(0.45);">
                  <div class="effect-1 effects" style="border-left: 3px solid rgb(255, 255, 255);"></div>
                  <div class="effect-2 effects" style="border-left: 3px solid rgb(255, 255, 255);"></div>
                  <div class="effect-3 effects" style="border-left: 3px solid rgb(255, 255, 255);"></div>
                </div>
              </div>
              Сохранить
            </vs-button>
            <vs-button
              type="border"
              class="float-right"
              :disabled="loading"
              @click.prevent="$emit('cancel')">Отменить</vs-button>
          </div>
        </div>
      </vs-card>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'SaveBlock',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>
